<template>
    <div id="pm-numeric-keyboard--wrapper">
        <div id="pm-numeric-keyboard--grid">
            <div @touchstart="onClick(key)" v-for="key in keys" :key="key" class="pm-numeric-keyboard--button" v-html="key" />
            <div @touchstart="onClear" class="pm-numeric-keyboard--button" v-html="'←'" />
        </div>
        <div id="pm-numeric-keyboard--submit">
            <span style="display: inline-block; padding: 10px;" @click="$emit('close')">
                <v-icon>check</v-icon>
            </span>
        </div>
    </div>
</template>

<style>
    #pm-numeric-keyboard--wrapper {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        z-index: 999999;
        /* box-shadow: 0 0 50px rgba(0,0,0,.25); */
        border-top: 10px solid #f5f5f5;
    }
    #pm-numeric-keyboard--grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr 1fr;
        gap: 10px 10px;
        margin: 10px 0;
    }
    .pm-numeric-keyboard--button {
        text-align: center;
        padding: 10px 0;
        font-size: 24px;
        font-weight: 600;
        color: #444;
    }
    .pm-numeric-keyboard--button:active {
        animation: pm-numeric-keyboard--button-animation 0.5s 1;
    }
    #pm-numeric-keyboard--submit {
        border-top: 10px solid #f5f5f5;
        text-align: center;
        font-size: 24px;
        font-weight: 600;
        color: #444;
    }

    @keyframes pm-numeric-keyboard--button-animation {
        0%   {
            background: rgba(0,0,0,.1);
         }
        100% {
            background: rgba(0,0,0,0);
         }
    }
</style>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: () => 0,
            required: true,
        },
        maxLength: {
            type: Number,
            default: () => 0,
        }
    },
    data: () => ({
        tmpValue: "0",
        keys: ["1","2","3","4","5","6","7","8","9",".","0"],
    }),
    created() {
        this.tmpValue = isNaN(this.value) ? "0" : this.value.toString();
    },
    methods: {
        onClick(key) {
            if (this.maxLength > 0 && this.tmpValue.length >= this.maxLength) return;
            if (this.tmpValue === "0") this.tmpValue = "";
            this.tmpValue += key;
            this.$emit('input', this.tmpValue);
        },
        onTouchEnd(event) {
            window.setTimeout(() => {
                event.target.classList.remove('ripple');
            }, 250);
        },
        onClear(event) {
            this.tmpValue = this.tmpValue.slice(0, -1);
            this.$emit('input', this.tmpValue);
        }
    }
}
</script>
